import { render, staticRenderFns } from "./BrickFilterCondition.vue?vue&type=template&id=b1c6b836&scoped=true&"
import script from "./BrickFilterCondition.vue?vue&type=script&lang=js&"
export * from "./BrickFilterCondition.vue?vue&type=script&lang=js&"
import style0 from "./BrickFilterCondition.vue?vue&type=style&index=0&id=b1c6b836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c6b836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c6b836')) {
      api.createRecord('b1c6b836', component.options)
    } else {
      api.reload('b1c6b836', component.options)
    }
    module.hot.accept("./BrickFilterCondition.vue?vue&type=template&id=b1c6b836&scoped=true&", function () {
      api.rerender('b1c6b836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickFilterCondition.vue"
export default component.exports